import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/style.css'
import '@/assets/css/theme.css'
import '@/assets/css/dark.css'
import '@/assets/css/font-icons.css'
import '@/assets/css/theme_fonts.css'
import '@/assets/css/medical-icons.css'
import '@/assets/css/stateface.css'
import '@/assets/css/theme_colors.css'
import router from './router'
import axios from 'axios'
import { store } from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faPhone,
    faFax,
    faEnvelope,
    faSearch,
    faBuilding,
    faNotesMedical,
    faTooth,
    faLifeRing,
    faBlind,
    faEye,
    faHospital,
    faRandom,
    faUsers,
    faUserFriends,
    faChild,
    faUserInjured,
    faFileCsv,
    faAddressCard,
    faFile,
    faCertificate, faDollarSign, faFolder, faBookOpen, faExclamationCircle, faBan, faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Gravatar from 'vue-gravatar'
import IdleVue from 'idle-vue'
import Vue2Filters from 'vue2-filters'
import { userPreferences } from './config/config'

Vue.use(Vue2Filters)
const eventsHub = new Vue()

Vue.use(IdleVue, {
    store: store,
    eventEmitter: eventsHub,
    idleTime: userPreferences.screenIdle
})
library.add(
    faPhone, faFax, faEnvelope, faSearch, faBuilding, faNotesMedical, faTooth, faLifeRing, faBlind, faEye, faHospital,
    faRandom, faUsers, faUserFriends, faChild, faUserInjured, faFileCsv, faFile, faDollarSign, faCertificate,
    faAddressCard, faFolder, faBookOpen, faExclamationCircle, faBan, faExclamationTriangle
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-gravatar', Gravatar)

Vue.use(BootstrapVue)
Vue.config.productionTip = false

//Auth checking
let token = localStorage.getItem('token')
//Axios header setup so it sends token on each request
axios.defaults.headers.common['Authorization'] = 'bearer ' + token
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        store.dispatch('logout').then(() => {
            router.push('/')
        })
    }
    return Promise.reject(error)
})

//Filters
import phone from './filters/phone_num'
import eldo_date from './filters/eldo_date'

Vue.filter('eldo_date', eldo_date)
Vue.filter('phone', phone)

import { mapGetters } from 'vuex'

new Vue({
    router,
    store,
    data () {
        return {
            logoutTimer: null,
        }
    },
    computed: {
        ...mapGetters(['countDown'])
    },
    onIdle () {
        this.logoutTimer = setInterval(() => {
            if (this.countDown <= 0) {
                store.dispatch('logout')
                clearInterval(this.logoutTimer)
            } else {
                store.commit('decCountDown')
            }
        }, 1000)
    },
    onActive () {
        store.commit('setCountDown', userPreferences.logoutTimeout)
        clearInterval(this.logoutTimer)
    },
    render: h => h(App)
}).$mount('#app')
